import Vue from 'vue'

/**
 * Adds cache tags for the provided IDs prefixed by the given tag.
 * @param {string} tag - The prefix for cache tags.
 * @param {number[]} ids - The IDs to create tags for.
 * @returns {string[]} Array of cache tags
 */
const addCacheTag = (tag: string, ids: any[] = []): string[] => {
  const cacheTags = Vue.prototype.$cacheTags || { add: () => { } }
  const tags: string[] = []

  if (ids.length === 0) {
    cacheTags.add(tag)
    tags.push(tag)
    return tags
  }

  if (tag === 'C' && ids.length > 500) {
    cacheTags.add('C_ALL')
    tags.push('C_ALL')
  } else {
    ids.forEach(id => {
      const tagString = `${tag}${id}`
      cacheTags.add(tagString)
      tags.push(tagString)
    })
  }

  return tags
}

export {
  addCacheTag
}
